import React from "react";
import { useParams } from "react-router-dom";
import Layout from "../../../../Components/Layout";
import AttendeeInformation from "../../../../Components/User/Events/Checkout/AttendeeInformation";

const AttendeeInformationPage = () => {
  const { eventId } = useParams();
  const query = new URLSearchParams(window.location.search);
  const referralId = query.get("referralId");
  let redirectUrl = "/purchase-tickets/" + eventId;
  if (referralId) {
    redirectUrl += `?referralId=${referralId}`;
  }

  return (
    <Layout Heading="Attendee Information" TitleClassName="event-attendee-title" HeadClassName="event-page-head event-attendee-head" DetailsHead LeftClassName="event-attendee-head-left" Sidebar={0} BackAction={redirectUrl} ExtraclassName="event-attendee-panel">
      <AttendeeInformation eventId={eventId} />
    </Layout>
  );
};

export default AttendeeInformationPage;
